import * as VehicleActions from '../actions/vehicle.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  isLoading: false,
  loadingById: {},
  pathSuccess: null,
};

export default function vehicle(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case VehicleActions.LOAD:
    case VehicleActions.LOAD_ONE:
      // case RequirementsActions.LOAD_CONTRACT:
      // case VehicleActions.CREATE:
      return {
        ...state,
        isLoading: true,
      };

    case VehicleActions.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.data.reduce((acc, item) => {
          acc[item.veh_patente] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.veh_patente),
        pathSuccess: null,
      };
    case VehicleActions.LOAD_SUCCESS_ONE:
      return {
        ...state,
        isLoading: false,
        entities: action.data /* .reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.id), */,
        pathSuccess: null,
      };
    // case AlarmVelActions.LOAD_CONTRACT_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     entitiesContract: action.data.reduce((acc, item) => {
    //       acc[item.id] = item;
    //       return acc;
    //     }, {}),
    //     idsContract: action.data.map((x) => x.id),
    //     pathSuccess: null
    //   };
    case VehicleActions.UPDATE_ONE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.data.id]: true,
        },
      };

    case VehicleActions.UPDATE_ONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data,
          },
        },
        loadingById: {
          ...state.loadingById,
          [action.data.id]: false,
        },
        // pathSuccess: '/dashboard/forecast/list'
      };

    case VehicleActions.UPDATE_ONE_FAILED:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.id]: false,
        },
      };

    case VehicleActions.CREATE_SUCCESS:
      // ids: action.users.map(x => x.id)
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data,
          },
        },
        ids: [...state.ids.filter((x) => x !== action.data.id), action.data.id],
        isLoading: false,
        // pathSuccess: '/dashboard/forecast/list'
      };
    case VehicleActions.CREATE_FAILED:
      return {
        ...state,
        isLoading: false,
      };

    case VehicleActions.DESTROY_SUCCESS:
      delete state.entities[action.id];
      // delete state.ids[action.id];

      return {
        ...state,
        entities: {
          ...state.entities,
        },
        ids: state.ids.filter((id) => id !== action.id),
        /* ids: [
          ...state.ids
          // action.user.id
        ] */
      };
    case VehicleActions.VOID:
      return {
        ...state,
        isLoading: false,
        entities: {},
        ids: [],
        group: {},
      };
    default:
      return state;
  }
}

export const getEntities = (state) => state.vehicle.entities;
export const getData = (state) => state.vehicle.ids.map((id) => state.vehicle.entities[id]);
export const getDataById = (state, id) => state.vehicle.entities[id];
export const getIsLoading = (state) => state.vehicle.isLoading;
// aths
export const getPath = (state) => state.vehicle.pathSuccess;
